import { render } from "./RecordDetailPage.vue?vue&type=template&id=8d395618&scoped=true"
import script from "./RecordDetailPage.vue?vue&type=script&lang=js"
export * from "./RecordDetailPage.vue?vue&type=script&lang=js"

import "./RecordDetailPage.vue?vue&type=style&index=0&id=8d395618&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d395618"]])

export default __exports__